function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5244 4.52628C14.2971 3.38419 13.7206 2.34081 12.8746 1.54017C12.0286 0.739533 10.9548 0.221118 9.80139 0.0564903C8.64802 -0.108137 7.47196 0.0891406 6.43555 0.621092C5.39915 1.15304 4.55351 1.99344 4.01537 3.02626C2.8702 3.15079 1.81635 3.70929 1.07066 4.58684C0.324976 5.4644 -0.0558225 6.59424 0.00662645 7.74389C0.0690754 8.89354 0.570021 9.97554 1.40638 10.7672C2.24274 11.5589 3.3509 12.0001 4.50282 12H14.2579C15.2274 11.9996 16.159 11.6233 16.8565 10.9503C17.554 10.2773 17.9631 9.36003 17.9976 8.39163C18.0322 7.42322 17.6895 6.47919 17.0417 5.75824C16.3938 5.03729 15.4915 4.59565 14.5244 4.52628Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.71094 6.92139L8.34019 8.55042L10.7847 5.29297",
  stroke: "#4D88FF",
  strokeWidth: 1.00495,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgCloud = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cloud.926852b4.svg";
export { ForwardRef as ReactComponent };